module.exports = __webpack_public_path__ + "img/odnoklassniki.9abd0fd1.svg";